'use client'

import { ReactNode } from 'react'
import ReactQueryProvider from './ReactQueryProvider'
import MuiThemeProvider from './MuiThemeProvider'
import { NestAuthProvider } from '@nestingale/auth/components'
import { configureAmplify } from '@/config/configureAmplify'
import ErrorBoundaryProvider from './ErrorBoundaryProvider'
import { LayoutProvider } from './LayoutProvider'

interface ProvidersProps {
  children: ReactNode
  brandName?: string
  layoutData?: {
    brand?: any
    globalData?: any
    headerMenuJson?: any
    pageInserts?: any
    env?: string
  }
}

// Ensure auth config is initialized before NestAuthProvider mounts
if (typeof window !== 'undefined') {
  configureAmplify()
}

export default function Providers({ 
  children, 
  brandName = 'nestingale', 
  layoutData 
}: ProvidersProps) {
  return (
    <ErrorBoundaryProvider>
      <ReactQueryProvider>
        <NestAuthProvider>
          <LayoutProvider initialData={layoutData}>
            <MuiThemeProvider brandName={brandName}>
              <div data-providers-initialized="true">
                {children}
              </div>
            </MuiThemeProvider>
          </LayoutProvider>
        </NestAuthProvider>
      </ReactQueryProvider>
    </ErrorBoundaryProvider>
  )
}